{
  "message": "hello i18n !!",
  "Product": "Product",
  "Features": "Features",
  "About": "About",
  "Login": "Login",
  "SignUp": "Sign Up",
  "JoinNow": "Join now!",
  "Continue": "Continue",
  "contactUs": "Contact Us",
  "ineditLong": "Inèdit Software SL",
  "terms": "Terms",
  "Add another": "Add another",
  "mailPlaceholder": "E.g. name{'@'}company.com",
  "email": "email",
  "Value is required": "Value is required",
  "Search": "Search",
  "Manage Workers": "Manage Workers",
  "Administration": "Administration",
  "Delete": "Delete",
  "Confirm": "Confirm",
  "Export PDF": "Export PDF",
  "No items selected": "No items selected",
  "New print Order": "New Print Order",
  "Items": "Item|Items",
  "Add new": "Add new",
  "Write your comments here": "Write your comments here...",
  "File": "File",
  "a new file": "a new file",
  "Quantity": "Quantity",
  "Units": "Units",
  "lets-print": "Let's print {0}!",
  "start": {
    "title1": "The easiest way to connect design brands with printing centers",
    "title2": "Inèdit Connect is the easiest, fastest and more reliable way to receive, manage and deploy print orders to your customers.",
    "description": "A {0} designed to bridge the gap {1} or brands and {2}. ",
    "description2": "This platform aims at revolutionazing the way we approach manufacturing, by providing a {0} for {1}."
  },
  "first": {
    "title": "First, tell us your email and password",
    "description": "It will be used as an administrator of the company",
    "agree": "By continuing, you agree to our {terms} and that you have read our {data-use-policy}, including {cookies-use}."
  },
  "second": {
    "title": "Tell us your company's name",
    "description": "This will be the name used to connect with partners"
  },
  "third": {
    "title": "Finally, add some workers of your company",
    "description": "They will be able to see and manage your company's printing workflow."
  },
  "otp": {
    "title": "Verify your email",
    "description": "We sent a verification code to",
    "verify": "Verify",
    "resend": "Resend code"
  },
  "pick-a-password": "Pick a password",
  "suggestions": "Suggestions",
  "password": "Password",
  "Email": "Email",
  "Name": "Name",
  "Type": "Type",
  "Select Type": "Select Type",
  "Address": "Address",
  "Street": "Street",
  "Code": "Code",
  "Cancel": "Cancel",
  "Save": "Save",
  "Printer Mill": "Printer Mill",
  "second.description": "This name will be used to connect with partners",
  "Workflow": "Workflow",
  "Preferences": "Preferences",
  "Application Preferences": "Application Preferences",
  "Surname": "Surname",
  "Weak": "Weak",
  "medium": "Medium",
  "strong": "Strong",
  "finish_signup": {
    "title": "Almost done!",
    "description": "You are only one step away from creating your account!"
  },
  "password_reset": {
    "title": "New password",
    "description": "Please, enter your new password below"
  },
  "reset_ok": {
    "title": "Password restored",
    "description": "Now you can log in with your new password."
  },
  "Your name": "Your name",
  "Company": "Company",
  "This is a test": "This is a test",
  "Number": "Number",
  "City": "City",
  "Zip": "Zip",
  "State": "State",
  "Country": "Country",
  "Welcome Back": "Welcome Back",
  "Do not have an account?": "Do not have an account?",
  "Create today!": "Create today!",
  "Password": "Password",
  "Remember me": "Remember me",
  "Log In": "Log In",
  "reset_password_description": "Enter the email associated with your account and we will send and email with a link and instructions to reset your password",
  "mail_sent_description": "We have sent an email to your email address with instructions to reset your password",
  "mail_not_received": "Did not receive the email? Check your spam folder or ",
  "Reset your password": "Reset your password",
  "Send": "Send",
  "Roles": "Roles",
  "New Order": "New Order",
  "Create": "Create",
  "View": "View",
  "Edit": "Edit",
  "Manage MaterialTypes": "Manage material types",
  "Roles & Permissions": "Roles & Permissions",
  "Please fill in all fields": "Please fill in all fields",
  "copies": "Copies",
  "in": "in",
  "inches": "Inches",
  "pixels": "Pixels",
  "meters": "Meters",
  "centimeters": "Centimeters",
  "Description": "Description",
  "Unit": "Unit",
  "No": "No",
  "Yes": "Yes",
  "Select units type": "Select units",
  "MaterialType deleted successfully": "Material type deleted successfully",
  "Date": "Date",
  "Designer Brand": "Designer Brand",
  "Edit MaterialType": "Edit material type",
  "New MaterialType": "New material type",
  "Discard changes": "Discard changes",
  "Changes not saved": "Changes not saved",
  "Are you sure you want to exit without saving": "Are you sure you want to exit without saving?",
  "Company name": "Company name",
  "Company alias": "Company alias",
  "MaterialType": "Material",
  "Measure": "Measure",
  "Units of measure": "Units of measure",
  "Choose a material first": "Choose a material first",
  "Split to new order": "Split to new order",
  "Delete Items": "Delete Items",
  "Drag and drop files here to upload": "Drag and drop files here to upload.",
  "Comments": "Comments",
  "Download": "Download",
  "Actions": "Actions",
  "Replace file": "Replace file",
  "Select or drag and drop in the box below the new file that you want to upload": "Select or drag and drop in the box below the new file that you want to upload",
  "Api Keys Management": "API Keys Management",
  "New token": "New Token",
  "Generate": "Generate",
  "Api_keys_description": "API tokens allow you to interact with our REST API and connect applications like Control Center or neoCatalog with Inèdit Connect. Take into account that the newly generated key will only be shown once, so be sure to copy it and store it into a save place.",
  "Last Used": "Last Used",
  "Date Created": "Date Created",
  "New Token": "New Token",
  "Copy": "Copy",
  "Do you want to delete this token?": "Do you want to delete this token?",
  "Do you want to delete this order?": "Do you want to delete this order?",
  "Orders": "Orders",
  "forgot_password_description": "Please enter your email below, if it is a valid address we will send you an email with the instructions to reset your password",
  "Select Role": "Select Role",
  "Select Country": "Select Country",
  "Users": "Users",
  "Workflows": "Workflows",
  "Materials": "Materials",
  "MaterialTypes": "Material types",
  "Partners": "Partners",
  "Pending": "Pending",
  "Discover": "Discover",
  "Pending invitations": "Pending invitations",
  "accept_partnership.title": "Congratulations!",
  "accept_partnership.description": "Now you are partners with {company}.",
  "Fix the errors in the form before continuing": "Fix the errors in the form before continuing",
  "Do you want to delete this item? This action cannot be undone.": "Do you want to delete this item? This action cannot be undone.",
  "Do you want to delete this items This action cannot be undone": "Do you want to delete this item? This action cannot be undone|Do you want to delete these items? This action cannot be undone",
  "Order deleted successfully": "Order deleted successfully",
  "There was an error deleting order": "There was an error deleting order",
  "There was an error creating the MaterialType": "There was an error creating the material type",
  "MaterialType created successfully": "Material type created successfully",
  "There was an error deleting the MaterialType": "There was an error deleting the material type",
  "MaterialType updated successfully": "Material type updated successfully",
  "There was an error updating the MaterialType": "There was an error updating the material type",
  "Select MaterialType": "Select material type",
  "token_warning": "This token will be shown only once. Please, copy it and store it in a save place.",
  "Skip this step. I will add workers later": "Skip this step. I will add workers later",
  "There should be at least one Admin user": "There should be at least one Admin user",
  "Are you sure you want to delete the selected Users": "Are you sure you want to delete the selected user?|Are you sure you want to delete the selected users?",
  "File History": "File History",
  "Max": "To",
  "Stock Available": "Stock available",
  "MaterialTypes Management": "Material types Management",
  "User email must be unique": "User email must be unique",
  "Value is not a valid email address": "Value is not a valid email address",
  "Price": "Price",
  "Min": "From",
  "Home": "Home",
  "Hello World!": "Hello Word!",
  "no_delete_self": "You can't delete yourself",
  "Please fill in all required fields": "Please fill in all required fields",
  "There are no items for this order please add new items with the button below": "There are no items for this order, please add new items with the button below",
  "pagination-text": "Showing {first} of {totalRecords} entry | Showing {first} to {last} of {totalRecords} entries ",
  "no-customers-found": "No customers found",
  "loading-customers-data-please-wait": "Loading customers data. Please wait.",
  "company description placeholder": "Tell us something about your company so your partners can get to know you better. E.g.: What products or services does your company offer? How does your company stand out from the competition?",
  "Company Address": "Company Address",
  "Company information saved": "Company information saved",
  "Failed to save company information": "Failed to save company information",
  "Company street": "Company street",
  "Zip Code": "Zip code",
  "Phone number": "Phone number",
  "Role": "Role",
  "Reject": "Reject",
  "Accept": "Accept",
  "items_deleted_successfully": "Item deleted successfully|{count} items deleted successfully",
  "Users deleted successfully": "User deleted successfully|{count} users deleted successfully",
  "validations": {
    "required": "The field {property} is required.",
    "minLength": "The {property} field must have a min length of {min}.",
    "maxLength": "The {property} field must have a max length of {max}.",
    "alphaNum": "The value can only contain letters and numbers."
  },
  "name": "name",
  "Select all": "Select all",
  "Do you want to split this item? A new order with _split suffix will be created": "Do you want to split this item? A new order with _split suffix will be created|Do you want to split these items? A new order with _split suffix will be created",
  "go back to": "go back to {name}",
  "Material Types": "Material types",
  "Manage material types": "Manage material types",
  "No material types found": "No material types found",
  "Loading material types data": {
    " Please wait": "Loading material types data. Please wait"
  },
  "No materials found": "No materials found",
  "Loading materialTypes data_Please wait": "Loading materials data. Please wait",
  "New Material Type": "New Material type",
  "Edit Material": "Edit Material",
  "New Material": "New material",
  "Select Material": "Select material",
  "Material deleted successfully": "Material deleted successfully",
  "There was an error updating the Material": "There was an error updating the Material",
  "Length": "Length",
  "Select Unit": "Select Unit",
  "There was an error moving the order": "There was an error moving the order",
  "Order created successfully": "Order created successfully",
  "No image file": "No item file",
  "Order edited successfully": "Order edited successfully",
  "Workflow saved": "Workflow saved",
  "Error saving workflow": "Error saving workflow",
  "Workflow Stages": "Workflow Stages",
  "workflowStages_description": "You can easily customize your workflows by adding new stages to your workflow. Just enter the name, description, and order of each stage. This provides flexibility and adaptability, allowing you to create workflows that fit your unique needs and improve productivity.",
  "Add": "Add",
  "Color": "Color",
  "Save changes": "Save changes",
  "Stage updated successfully": "Stage updated successfully",
  "Stage created successfully": "Stage created successfully",
  "Error updating stage": "Error updating stage",
  "Error creating stage": "Error creating stage",
  "Do you want to delete this stage": "Do you want to delete this stage?",
  "Please save or cancel the changes before editing another stage": "Please save or cancel the changes before editing another stage",
  "Please save or cancel the changes before adding another stage": "Please save or cancel the changes before adding another stage",
  "Delete Workflow": "Delete Workflow",
  "Default Stage": "Default Stage",
  "Default workflow stage": "Default workflow stage",
  "Workflow deleted": "Workflow deleted",
  "Error deleting workflow": "Error deleting workflow",
  "Do you want to delete this workflow Changes cant be undone": "Do you want to delete this workflow? Changes can't be undone.",
  "Add workflow": "Add workflow",
  "Order received to be reviewed and accepted or rejected": "Order received to be reviewed and accepted or rejected",
  "Order that has been received": "Order that has been received",
  "Order is being worked on": "Order is being worked on",
  "Order has been completed": "Order has been completed",
  "Order has been rejected": "Order has been rejected",
  "Drag and drop orders here to send them to the printer mill": "Drag and drop orders here to send them to the printer mill",
  "Incoming Orders": "Incoming Orders",
  "Please enter a reason for rejection": "Please enter a reason for the rejection",
  "New Comment:": "New Comment:",
  "Unsaved changes": "Unsaved changes",
  "Continue without saving": "Continue without saving",
  "you-have-unsaved-changes-do-you-want-to-save-or-continue-losing-your-changes": "You have unsaved changes. Do you want to save or continue losing your changes?",
  "cant delete workflow with orders": "Can't delete workflow with orders",
  "Move to stage": "Move to stage",
  "There was an error moving the item": "There was an error moving the item",
  "Add items first": "Add items first",
  "Default workflow": "Default workflow",
  "Accept partner orders automatically": "Accept partner orders automatically",
  "Order item has been archived": "Order item has been archived",
  "Show Archived": "Show archived",
  "Order item archived successfully": "Order item archived successfully",
  "Error while archiving order item": "Error while archiving order item",
  "Archive": "Archive",
  "Global Settings": "Global Settings",
  "Send to partner": "Send to partner",
  "Some items failed to send": "Some items failed to send: {successful}/{total} successful",
  "Order items sent to partner": "Order items sent to partner: {successful}/{total} successful",
  "Failed to send order items to partner": "Failed to send order items to partner",
  "Sku": "SKU",
  "Material Type": "Material Type",
  "Pieces": "Pieces",
  "Select material type": "Select material type",
  "Reject order": "Reject order",
  "Order items deleted successfully": "Order items deleted successfully",
  "Order items archived successfully": "Order items archived successfully",
  "Go to login page": "Go to login page",
  "Partner preferences saved successfully": "Partner preferences saved successfully",
  "Select Columns": "Select columns",
  "Columns": "Columns",
  "Services": "Services",
  "Printing": "Printing",
  "Designing": "Designing",
  "Activity history": "Activity History",
  "to": "to",
  "created this order item": "{name} created this order item",
  "created a print job for this order item": "{name} created a print job for this order item",
  "Delivery Date": "Delivery Date",
  "Printers": "Printers",
  "No printers found": "No printers found",
  "Loading printers data. Please wait": "Loading printers data. Please wait",
  "are-you-sure-delete-printer": "Are you sure you want to delete this printer?",
  "Printer deleted successfully": "Printer deleted successfully",
  "There was an error deleting the Printer": "There was an error deleting the Printer",
  "printer deleted successfully": "Printer deleted successfully",
  "Default Scheme": "Default Scheme",
  "URL": "URL",
  "Port": "Port",
  "Hidden": "Hidden",
  "Workstation": "Workstation",
  "UUID": "UUID",
  "No actions selected": {
    " Add actions with button below": "No actions selected. Add actions with the button below."
  },
  "Add Action": "Add action",
  "Select action": "Select action",
  "Status": "Status",
  "Order Code": "Order Code",
  "Order Name": "Order Name",
  "Object Size": "Object Size",
  "Search by code": "Search by code",
  "Search by name": "Search by name",
  "Search by file": "Search by file",
  "Search by description": "Search by description",
  "Select actions": "Select actions",
  "No partner": "No partner",
  "Order": "Order",
  "Publish": "Publish",
  "It will we displayed publicly": "It will be displayed publicly",
  "ActivitiesHistory": "Activities History",
  "Order has no items": "Order has no items",
  "As the order has no items it will be deleted": "As the order has no items it will be deleted",
  "Licenses": "Licenses",
  "Customer": "Customer",
  "ratings": "review|reviews",
  "Rating saved successfully": "Review saved successfully",
  "Error while saving rating": "Error while saving review",
  "No comments yet": "No comments yet",
  "Do you want to delete this order items": "Do you want to delete this order item?|Do you want to delete these {count} order items?",
  "Write a review": "Write a review",
  "Edit review": "Edit review",
  "Reply": {
    "": "Reply"
  },
  "Do you want to delete this response": "Do you want to delete this response?",
  "Add Rating": "Add Rating",
  "Something went wrong Please try again later": "Something went wrong. Please try again later.",
  "couldnt-connect-to-the-server-please-try-again-later": "Couldn't connect to the server. Please try again later.",
  "you-are-not-connected-to-the-internet-verify-your-connection-and-then-try-again": "You are not connected to the internet. Verify your connection and then try again.",
  "something-went-wrong-please-try-again-later": "Something went wrong. Please try again later.",
  "do-you-want-to-delete-this-company": "Do you want to delete this company? All data, including orders, users, workflows, etc. will be deleted.",
  "we-have-sent-you-an-email-with-instructions-to-delete-your-company-and-all-your-data": "We have sent you an email with instructions to delete your company and all your data.",
  "Check your email": "Check your email",
  "Ok": "Ok",
  "company-successfully-deleted": "Company successfully deleted",
  "Logout": "Logout",
  "At least one lowercase": "At least one lowercase",
  "At least one uppercase": "At least one uppercase",
  "At least one numeric": "At least one numeric",
  "Minimum 8 characters": "Minimum 8 characters",
  "Email already taken": "Email already taken",
  "Email is required": "Email is required",
  "Email is not valid": "Email is not valid",
  "now-tell-us-your-company-name": "Tell us your company's name",
  "This will be the name used to connect with partners": "This name will be used to connect with partners",
  "settings": "Settings",
  "Tell us how was the experience with your partner": "Tell us how was the experience with your partner",
  "Partners discovery": "Partners discovery",
  "Discover new partners": "Discover new partners",
  "select-services": "Select Services",
  "Showing X results": "Showing 0 results|Showing 1 result|Showing {count} results",
  "Rating": "Rating",
  "Partners since": "Partners since",
  "replied": "replied",
  "generic-column-with-no-special-dividers": "Generic: Column with no special dividers",
  "partners-column-with-sections-for-each-one-of-the-companys-partners": "Partners: Column with sections for each one of the company's partners",
  "printers-column-with-sections-for-each-one-of-the-companys-printers": "Printers: Column with sections for each one of the company's printers",
  "Drag and drop a file here to upload": "Drag and drop a file here to upload",
  "material-type-is-required": "Material type is required.",
  "name-is-required": "Name is required.",
  "do-you-want-delete-this-partnership": "Do you want to delete this partnership?",
  "submit": "Submit",
  "please-enter-the-email-address-of-one-of-the-allowed-super-admins-we-will-send-you-an-email-with-instructions-on-how-to-access": "Please enter the email address of one of the allowed super admins. We will send you an email with instructions on how to access.",
  "email-sent": "Email sent",
  "error-sending-email": "Error sending the email",
  "There was an error verifying the access token": "There was an error verifying the access token",
  "Only alphanumeric characters are allowed": "Only alphanumeric characters are allowed",
  "loading": "Loading...",
  "alias": "Alias",
  "created": "Created",
  "Alias": "Alias",
  "Icon": "Icon",
  "Add new service": "Add new service",
  "Services saved successfully": "Services saved successfully",
  "There was an error saving the services": "There was an error saving the services",
  "Error rejecting invitation": "Error rejecting invitation",
  "Error accepting invitation": "Error accepting invitation",
  "You are not authorized to perform this action": "You are not authorized to perform this action",
  "There was an error creating the Order": "There was an error creating the Order",
  "There was an error downloading the PDF": "There was an error downloading the PDF",
  "Partnership rejected successfully": "Partnership request rejected successfully",
  "Search by units": "Search by units",
  "Are you sure you want to delete this service": "Are you sure you want to delete this service?",
  "Delete service": "Delete service",
  "Do you want to archive this order items": "Do you want to archive this order item?|Do you want to archive this order items?",
  "no-partners-column": "To send an order item to a partner you should create a \"partners type\" column first",
  "error-uploading-file": "Error uploading file",
  "file-uploaded-successfully": "File uploaded successfully",
  "Company ratings": "Company ratings",
  "Error while saving partner preferences": "Error while saving partner preferences",
  "Private Comment": "Private comment",
  "Public comment": "Public comment",
  "public-comment-tooltip": "If this item is shared with a partner they will be able to see public comments",
  "Accept partnership": "Accept partnership",
  "Reject partnership": "Reject partnership",
  "Schemes for": "Schemes for",
  "Schemes": "Schemes",
  "Active": "Active",
  "Public": "Public",
  "Email not allowed": "Email not allowed",
  "Scheme files": "Scheme files",
  "MaterialType with this name already exists": "Material type with name this name already exists",
  "Comment deleted successfully": "Comment deleted successfully",
  "There was an error deleting the comment": "There was an error deleting the comment",
  "There was an error editing the": "There was an error editing the ",
  "edited_successfully": " edited successfully",
  "comment": "comment",
  "Comment": "Comment",
  "Reset to default": "Reset to default",
  "do-you-want-to-block-this-partnership": "Do you want to block this partner?",
  "Block": "Block",
  "Unblock": "Unblock",
  "material-edited-successfully": "Material edited successfully",
  "material-updated-successfully": "Material updated successfully",
  "there-was-an-error-updating-the-material": "There was an error updating the material",
  "are-you-sure-you-want-to-delete-this-company": "Are you sure you want to delete this company?",
  "to-confirm-please-write-delete-on-the-box-below": "To confirm, please write DELETE on the box below",
  "Statistics": "Statistics",
  "Edited at": "Edited",
  "Expired": "Expired",
  "A company already exists with this name": "A company already exists with this name",
  "Analytics": "Analytics",
  "today": "Today",
  "this-month": "This Month",
  "last-month": "Last Month",
  "this-quarter": "This Quarter",
  "Meters": "Meters",
  "Total": "Total",
  "By date": "By Date",
  "due date": "due date",
  "order-items-by-material-type": "Order Items by Material Type",
  "hello": "Hello",
  "last-30-days": "Last 30 days",
  "last-3-months": "Last 3 Months",
  "this-year": "This year",
  "last-365-days": "Last 365 days",
  "forgot-password": "Forgot Password?",
  "cutting": "Cutting",
  "accepted": "Accepted",
  "idle": "Idle",
  "in-queue": "In queue",
  "Idle": "Idle",
  "disable_job": "Disable job",
  "Disable_job": "Disable job",
  "enable_job": "Enable job",
  "print_start": "Print start",
  "print_progress": "Printing progress",
  "In queue": "In queue",
  "Finished": "Finished",
  "order-items-by-customer": "Order Items by Partner",
  "order-items-by-workflow-stage": "Order Items by Workflow Stage",
  "Inches": "Inches",
  "Centimeters": "Centimeters",
  "Copies": "Copies",
  "select-status": "Select status",
  "No statuses found": "No statuses found",
  "x-items-selected": "{count} items selected",
  "File Name": "File Name",
  "Creation Date": "Creation Date",
  "USER": "User",
  "User": "User",
  "Manager": "Manager",
  "Admin": "Admin",
  "Guest": "Guest",
  "order-items-by-status": "Order Items by Status",
  "send-email-to-owner": "Send email to owner",
  "send-email-to-items-owner": "Send email to item's owner",
  "Generic": "Generic",
  "EDIT": "EDIT",
  "VIEW": "VIEW",
  "CREATE": "CREATE",
  "DELETE": "DELETE",
  "Companies": "Companies",
  "Permissions": "Permissions",
  "Prices": "Prices",
  "partner": "Partner",
  "Material": "Material",
  "Force touch displays accessibility": "Force accessibility for touch screens",
  "company-info": "Company info",
  "company-name-preferences": "{name} preferences",
  "download-csv": "Download CSV",
  "cant-delete-item-because-it-has-been-sent-to-a-partner": "Can't delete item because it has been sent to a partner",
  "there-was-an-error-deleting-the-item": "There was an error deleting the item",
  "select-a-workflow": "Select workflow",
  "TShirt": "TShirt",
  "Linen": "Linen",
  "Cotton": "Cotton",
  "Tulle": "Tulle",
  "TShirt Red": "TShirt Red",
  "Silk": "Silk",
  "items-by-company": "Items by Company",
  "users-by-company": "Users by Company",
  "x-columns-selected": "{count} columns selected",
  "Order items": "Items",
  "Workflow Stage": "Workflow Stage",
  "upcoming-due": "Upcoming or Expired due date",
  "Filter by": "Filter by",
  "Dashboard": "Dashboard",
  "Width": "Width",
  "Not specified": "Not specified",
  "Feet": "Feet",
  "Yards": "Yards",
  "material-width-is-required": "Units are required",
  "units-required": "Units are required",
  "Close": "Close",
  "All": "All",
  "All orders": "All",
  "All order items": "All",
  "Yesterday": "Yesterday",
  "last-7-days": "Last 7 days",
  "quantity-cant-be-0": "Quantity can't be 0",
  "rejected": "Rejected",
  "no-incoming-items-found": "No incoming items found",
  "Unstarted": "Unstarted",
  "Started": "Started",
  "Done": "Done",
  "Undefined": "Undefined",
  "Archived": "Archived",
  "Invite": "Invite",
  "Starts with": "Starts with",
  "Contains": "Contains",
  "Not contains": "Not contains",
  "Ends with": "Ends with",
  "Equals": "Equals",
  "Not equals": "Not equals",
  "No Filter": "No Filter",
  "Less than": "Less than",
  "Less than or equal to": "Less than or equal to",
  "Greater than": "Greater than",
  "Greater than or equal to": "Greater than or equal to",
  "Date is": "Date is",
  "Date is not": "Date is not",
  "Date is before": "Date is before",
  "Date is after": "Date is after",
  "Clear": "Clear",
  "Apply": "Apply",
  "Match All": "Match All",
  "Match Any": "Match Any",
  "Blocked": "Blocked",
  "Manage ink types": "Manage ink types",
  "default-workflow-stage-for-incoming-orders-must-be-a-generic-stage": "Default workflow stage for incoming orders must be a Generic stage",
  "a-stage-that-is-set-as-default-of-a-workflow-can-only-be-generic": "A stage that is set as default of a workflow can only be Generic",
  "a-stage-that-is-set-as-default-from-partner-preferences-can-only-be-generic": "A stage that is set as default from partner preferences can only be Generic",
  "Stage deleted successfully": "Stage deleted successfully",
  "Height": "Height",
  "Choose destinataries": "Choose recipients",
  "send-email-to-address": "Send email to recipients",
  "Send an email to any email address specified": "Sends an email to any email address specified",
  "there-was-an-error-creating-the-user": "There was an error creating the user",
  "User already exists with": "User already exists with",
  "are-you-sure-delete-ink": "Are you sure you want to delete this ink?|Are you sure you want to delete this inks?",
  "No ink types found": "No ink types found",
  "InkType deleted successfully": "Ink type deleted successfully",
  "There was an error deleting the InkType": "There was an error deleting the ink type",
  "New Ink Type": "New Ink Type",
  "InkType created successfully": "Ink type created successfully",
  "There was an error creating the InkType": "There was an error creating the ink type",
  "Search by ink types": "Search by ink types",
  "Select inks type": "Select inks type",
  "InkTypes": "Ink types",
  "permissions-saved": "Permissions saved",
  "error-saving-permissions": "Error saving permissions",
  "you-dont-have-permission-to-perform-this-action": "You don't have permission to perform this action",
  "View/Edit": "View/Edit",
  "length-units": "Length units",
  "items": "items",
  "Select stage": "Select stage",
  "date-placeholder": "dd/mm/yyyy",
  "file-name": "File Name",
  "uploaded-at": "Uploaded At",
  "accepted-plural": "Accepted",
  "items_plural": "Items",
  "You": "You",
  "changed": "changed",
  "you-have-changed-field-to-new": " have {verb} {field} to {value}|{name} have {verb} {field} to {value}|{name} has {verb} {field} to {value}",
  "set": "set",
  "and": "and",
  "Order Item": "Order Item",
  "length": "length",
  "lengthUnits": "Length units",
  "position": "position",
  "workflow-stage": "workflow stage",
  "history-position": "the position",
  "history-status": "the status",
  "Accepted": "Accepted",
  "history-quantity": "the quantity",
  "history-width": "the width",
  "history-widthUnits": "the width units",
  "history-lengthUnits": "the length units",
  "history-length": "the length",
  "history-description": "the description",
  "email-address": "Email address",
  "we-have-detected-that-you-dont-belong-to-any-company": "We have detected that you don't belong to any company, you can create a new one or ask a company admin to invite you",
  "create-new-company": "Create new company",
  "Reason for rejection": "Reason for the rejection",
  "Error downloading file": "Error downloading file",
  "there-was-an-error-downloading-the-file": "There was an error downloading the file",
  "remove-all-filters": "Remove all filters",
  "Partner": "Partner",
  "Partner Mat": {
    " SKU": "Partner "
  },
  "Partner Material SKU": "Partner's SKU",
  "material-name-partner": "Partner's material name",
  "Deleted": "Deleted",
  "MaterialType has materials associated with it": {},
  "Cannot delete this Material Type because it has materials associated with it": "Cannot delete this Material Type because it has materials associated with it",
  "Cannot delete this Material because it has order items associated with it": "Cannot delete this Material because it has order items associated with it",
  "select-your-company": "Select your company",
  "we-have-detected-that-you-belong-to-more-than-one-company-please-choose-the-company-you-wish-to-log-in-with": "We have detected that you belong to more than one company. Please choose the company you wish to log in with.",
  "Material already exists with": "Material already exists with",
  "Sort order": "Sort order",
  "Sort by": "Sort by",
  "Any": "Any",
  "Order items moved to stage": "Order items moved to stage",
  "Role is required": "Role is required",
  "units-are-required": "Units are required",
  "Select partner": "Select partner",
  "select-sorting-method": "Select sorting method",
  "Encrypted": "Encrypted",
  "Outgoing Orders": "Outgoing Orders",
  "Job": "Job",
  "Encrypt jobs": "Encrypt jobs",
  "Encrypt outgoing jobs before sending them to your partner": "Encrypt outgoing jobs before sending them to your partner",
  "Send the item file as it is": "Send the item file as it is",
  "Send ": {
    "xjb jobs instead of files": "Send .xjb jobs instead of files"
  },
  "Third Party Licenses": "Third Party Licenses",
  "resolution-x": "Resolution X",
  "resolution-y": "Resolution Y",
  "Profile": "Profile",
  "num-channels": "Num. Channels",
  "num-colorways": "Num. Colorways",
  "No image file. Please request the partner to upload the image again.": "No image file. Please request the partner to upload the image again.",
  "file_size_exceeded": "The file {name} exceeds the size limit of {size} MB",
  "file_type_not_allowed": "File type \"{type}\" not allowed",
  "There is no maximum": "There is no maximum",
  "All the extensions": "All the extensions",
  "Configuration": "Configuration",
  "Allowed file extensions": "Allowed file extensions",
  "maximum-file-size-in-megabytes-mb": "Maximum file size in megabytes (MB)",
  "configuration-updated": "Configuration updated",
  "error-updating-configuration": "Error updating configuration",
  "Manage services": "Manage services",
  "Ratings": "Reviews",
  "Reviews": "Reviews",
  "hey-there-just-wanted-to-let-you-know-that-weve-been-using-some-awesome-third-party-libraries-and-tools-to-help-us-develop-our-software-these-open-source-licenses-have-been-a-huge-help-in-making-our-project-more-efficient-and-effective-were-super-grateful-for-the-hard-work-and-dedication-of-the-developers-who-created-these-tools-and-were-excited-to-keep-using-them-to-make-our-project-even-better": "Hey there! Just wanted to let you know that we've been using some awesome third-party libraries and tools to help us develop our software. These open-source licenses have been a huge help in making our project more efficient and effective. We're super grateful for the hard work and dedication of the developers who created these tools, and we're excited to keep using them to make our project even better!",
  "Third-party licenses": "Third-party licenses",
  "third-party-licenses-description": "Hey there! Just wanted to let you know that we've been using some awesome third-party libraries and tools to help us develop our software. These open-source licenses have been a huge help in making our project more efficient and effective. We're super grateful for the hard work and dedication of the developers who created these tools, and we're excited to keep using them to make our project even better!",
  "third-party-software-that-is-part-of-the-web-application": "Third-party software that is part of the web application:",
  "file-too-large": "Invalid file size, the file size should be smaller than {maxSize} MB.",
  "Primary": "Primary",
  "Surface": "Surface",
  "Encrypted in the partner": "Encrypted in the partner",
  "Pending information": "Pending information",
  "Table": "Table",
  "Compact cards": "Compact cards",
  "Full sized cards": "Full-sized cards",
  "Custom Fields": "Custom Fields",
  "Custom Dialogs": "Custom Dialogs",
  "add-custom-field": "Add custom field",
  "field-type": "Field type",
  "text": "text",
  "Label": "Label",
  "Text": "Text",
  "Boolean": "Boolean",
  "Options": "Options",
  "insert-field-available-options": "Type and press 'Enter' to add each option",
  "custom-field-deleted": "Custom field deleted",
  "error-deleting-custom-field": "Error deleting custom field",
  "Dropdown": "Dropdown",
  "Multiselect": "Multiselect",
  "default-value": "Default value",
  "manage-custom-dialogs": "Manage custom dialogs",
  "add-custom-dialog": "Add custom dialog",
  "dialog-title": "Dialog title",
  "Title": "Title",
  "this-title-will-be-shown-on-the-dialog-header": "This title will be shown on the dialog header",
  "No Status": "No Status",
  "No Material": "No Material",
  "do-you-want-to-delete-this-item": "Do you want to delete this item?",
  "Fields": "Fields",
  "Required": "Required",
  "Read only": "Read only",
  "TextArea": "Text area",
  "this-cant-be-undone": "This change can't be undone",
  "delete-question": "Delete?",
  "add-new-filed": "Add new filed",
  "select-a-field": "Select field",
  "Custom fields": "Custom fields",
  "Entity": "Entity",
  "order-new-custom-field": "order-new-custom-field",
  "new-custom-field": "New Custom Field",
  "New Custom Field": "New Custom Field",
  "custom-field-saved": "Custom field saved successfully",
  "custom-dialog-saved": "Custom dialog saved",
  "custom-dialog-save-error": "Error saving custom dialog",
  "Custom field saved": "Custom field saved",
  "error-saving-custom-field": "Error saving custom field",
  "Su": "Su",
  "Mo": "Mo",
  "Tu": "Tu",
  "We": "We",
  "Th": "Th",
  "Fr": "Fr",
  "Sa": "Sa",
  "January": "January",
  "February": "February",
  "March": "March",
  "April": "April",
  "May": "May",
  "June": "June",
  "July": "July",
  "August": "August",
  "September": "September",
  "October": "October",
  "November": "November",
  "December": "December",
  "error-deleting-users": "Error deleting user|Error deleting users",
  "or-login": "Or Login",
  "about-us": "About Us",
  "project": "Project",
  "no-available-options": "No available options",
  "user-created-successfully": "User created successfully",
  "Rejected": "Rejected",
  "Disable job": "Disabled job",
  "Print end": "Print end",
  "Print End": "Print Ended",
  "error-deleting": "Error deleting",
  "deleted-successfully": "Deleted successfully",
  "internal-use-field": "Internal use field, can't be modified",
  "Filter": "Filter",
  "Ascending": "Ascending",
  "Descending": "Descending",
  "select-order": "Select order",
  "show-expired": "Show Expired",
  "show-expired-files": "Show expired files",
  "error-resetting-custom-dialog": "There was an error reseting custom dialog",
  "custom-dialog-has-values": "There are values set for custom fields of this dialog",
  "together": "together",
  "apply-to-all": "Apply to all",
  "Catalan": "Catalan",
  "Italian": "Italian",
  "Spanish": "Spanish",
  "English": "English",
  "search-by-material": "Search by material",
  "select-material": "Select material",
  "no-materials-found": "No materials found",
  "data-use-policy": "Data Use Policy",
  "cookies-use": "Cookies Use",
  "drop-files-here-to-create-a-new-order": "Drop files here to create a new order",
  "drop-files-here": "Drop files here",
  "drop-files-here-default-order": "Drop files here for a default order",
  "Show less": "Show less",
  "Show more": "Show more",
  "No information available": "No information available",
  "Page height": "Page height",
  "Page width": "Page width",
  "order-item-moved-to-stage-name-successfully": "Order item moved to stage \"{name}\" successfully",
  "send-it-again": "send it again",
  "Move to workflow": "Move to workflow",
  "Sunday": "Sunday",
  "Monday": "Monday",
  "Tuesday": "Tuesday",
  "Wednesday": "Wednesday",
  "Thursday": "Thursday",
  "Friday": "Friday",
  "Saturday": "Saturday",
  "Sun": "Sun",
  "Mon": "Mon",
  "Tue": "Tue",
  "Wed": "Wed",
  "Thu": "Thu",
  "Fri": "Fri",
  "Sat": "Sat",
  "Jan": "Jan",
  "Feb": "Feb",
  "Mar": "Mar",
  "Apr": "Apr",
  "Jun": "Jun",
  "Jul": "Jul",
  "Aug": "Aug",
  "Sep": "Sep",
  "Oct": "Oct",
  "Nov": "Nov",
  "Dec": "Dec",
  "back-to-login": "Back to login",
  "add-order-type": "Add order type",
  "order-type-stage": "Default stage",
  "are-you-sure": "Are you sure?",
  "are-you-sure-you-want-to-delete-this-order-type": "Are you sure you want to delete this order type?",
  "delete-order-type": "Delete order type",
  "you-have-unsaved-changes-if-you-leave-now-you-may-lose-yor-changes-are-you-sure-you-want-to-leave": "You have unsaved changes. If you leave now you may lose yor changes, are you sure you want to leave?",
  "Order Type": "Order Type",
  "commmunity-platform": "community platform",
  "between-designers": "between designers",
  "printer-mills": "printer mills",
  "follow-us": "Follow us",
  "centrilized-hub": "centralized hub",
  "collaboration-communication-and-creativity": "collaboration, communication and creativity",
  "id": "Id",
  "order": "Order",
  "CurrentFile": "Current file",
  "OrderId": "Order Id",
  "Line": "Line",
  "WorkflowStageId": "Workflow stage id",
  "ParentId": "Parent order Id",
  "CurrentFileId": "Current file Id",
  "Position": "Position",
  "Order Types": "Order Types",
  "manage-company-and-services-in-administration": "Manage Company and Services in Administration",
  "manage-orders-in-workflows-view": "Manage orders in Workflows view",
  "manage-roles-and-permissions-in-administration": "Manage 'Roles & Permissions' in Administration",
  "manage-materials-in-administration": "Manage Materials in Administration",
  "manage-users-in-administration": "Manage Users in Administration",
  "manage-workflows-in-administration": "Manage Workflows in Administration",
  "manage-partners-in-administration-also-manage-partners-in-partners-discovery": "Manage Partners in Administration. Also manage partners in Partners Discovery",
  "manage-activity-history-of-the-orders-in-workflows-view": "Manage Activity History of the orders in Workflows view",
  "information-not-available-for-this-entity": "Information not available for this entity",
  "Checkbox": "Checkbox",
  "Repetitions": "Repetitions",
  "propagate-units-to-all-items": "Propagate units to all items",
  "default-workflow-stage-for-incoming-orders-cant-be-a-partners-stage": "Default workflow stage for incoming orders can't be a 'partners' stage",
  "Developers": "Developers",
  "layouts": "Layouts",
  "no-layouts-found": "No layouts found",
  "there-was-an-error-fetching-the-layouts": "There was an error fetching the layouts",
  "new-layout": "New Layout",
  "layout-name-placeholder": "New layout",
  "choose-file": "Choose file",
  "upload-layout-file": "Upload layout file",
  "upload-layouts-individually-in-bulk-or-as-a-zip-archive-any-files-with-matching-names-will-be-automatically-updated-with-your-new-versions": "Upload layouts individually, or in bulk. Any existing files with matching names will be automatically updated with your new versions.",
  "Upload files": "Upload files",
  "Upload": "Upload",
  "Preparing files": "Preparing files",
  "Error": "Error",
  "default-layout": "Default layout",
  "default-layout-description": "This layout will be applied to the order when creating the job file",
  "Layout": "Layout",
  "Layout selected": "Layout selected",
  "Number of pages": "Number of pages",
  "number-of-inputs": "Number of images",
  "allowed-users": "Allowed Users",
  "Visible": "Visible",
  "layout-updated-successfully": "Layout updated successfully",
  "attachments": "Attachments",
  "show-attachments": "Show Attachments",
  "layout-cant-be-changed-after-the-order-has-been-created": "Layout can't be changed after the order has been created",
  "error-accepting-order": "Error accepting order",
  "order-type-cant-be-changed-after-the-order-has-been-created": "Order type can't be changed after the order has been created",
  "Layouts": "Layouts",
  "users-and-access": "Users & Access",
  "Organization": "Organization",
  "system-configuration": "System Configuration",
  "workflow-&-orders": "Workflow & Orders",
  "Resources": "Resources",
  "error-saving-the-stage": "Error saving the stage",
  "stage-saved-successfully": "Stage saved successfully",
  "Workflow already exists with same name": "Workflow already exists with same name",
  "accept_partnership": {
    "description": "Now you are partners with {company}."
  },
  "Already partners": "Already partner",
  "verification-email-sent": "Verification email sent",
  "verification-email-description": "Please check your inbox and click the verification link to activate your account. This step is required to complete your registration and access all features.",
  "mail_not_received_verification": "Did not receive the email? Check your spam folder",
  "user-account-not-verified": "User account not verified",
  "sorry-this-user-email-has-not-been-verified-please-check-your-inbox-for-the-verification-email": "Sorry, this user email has not been verified. Please, check your inbox for the verification email.",
  "company-is-not-active": "Company is not active",
  "sorry-the-company-you-are-trying-to-access-is-not-active-please-contact-your-company-administrator": "Sorry, the company you are trying to access is not active. Please wait until our sales team validates this account.",
  "default-workflow-description": "When creating an order it will be placed in this workflow automatically",
  "Optimize jobs": "Optimize jobs",
  "some-file-types-are-not-compatible-with-layouts": "Some file types are not compatible with layouts",
  "file-type-is-not-supported-in-layouts": "File type is not supported in layouts",
  "supported-file-types-are": "Supported file types are",
  "failed-to-delete-order-items": "Failed to delete order items",
  "cant-delete-item-because-it-has-children": "Can't delete item because it has been accepted by a partner",
  "selected-items": "selected items",
  "an-order-with-status-accepted-cannot-be-moved": "An order with status 'Accepted' cannot be moved",
  "Cannot do this action because at least one item it has been sent to a partner": "Cannot do this action because at least one order has been sent to a partner",
  "there-was-an-error-loading-the-order-items": "There was an error loading the order items.",
  "Created by": "Created by",
  "Created By": "Created By",
  "Customers": "Customers",
  "Phone": "Phone",
  "new-customer": "New customer",
  "are-you-sure-you-want-to-delete-this-customer": "Are you sure that you want to delete this customer?",
  "customer-deleted-successfully": "Customer deleted successfully",
  "send-a-webhook-to-specified-url": "Send a webhook to specified URL",
  "send-webhook": "Send webhook",
  "enter-webhook-url": "Enter webhook URL",
  "Webhook sent": "Webhook sent",
  "Error sending webhook": "Error sending webhook",
  "Request failed with status code 404": "Request failed with status code 404: Not found",
  "webhook-url-is-required": "Webhook URL is required",
  "pre-process-layout": "Pre-process layout",
  "pre-process-layout-description": "If selected, the template will be preprocessed in the cloud to generate a job before sending it to print. If not selected, the template will be applied after it is sent to the printer. ",
  "Printer": "Printer",
  "Scheme": "Scheme",
  "Print automatically": "Print Auto",
  "search-by-customer": "Search by customer",
  "search-by-layout": "Search by layout",
  "search-by-scheme": "Search by scheme",
  "search-by-printer": "Search by printer",
  "item": "Item",
  "select-printer": "Select printer",
  "select-scheme": "Select scheme",
  "pages": "page|pages",
  "images": "image|images",
  "removed": "removed",
  "removed-field": "have removed {field}|{name} have removed {field}|{name} has removed {field}",
  "Batch created successfully": "Batch {batchNumber} created successfully",
  "Failed to create batch": "Failed to create batch",
  "Cannot create batch with items that already belong to another batch": "Cannot create batch with items that already belong to another batch",
  "Create a batch": "Create a batch",
  "Manage batch": "Manage batch",
  "Cannot mix items with and without batch. Select only items without batch to create, or only items with batch to manage.": "Cannot mix items with and without batch. Select only items without batch to create, or only items with batch to manage.",
  "Create a new batch with selected items": "Create a new batch with selected items",
  "Add selected items to an existing batch": "Add selected items to an existing batch",
  "Remove selected items from their batches": "Remove selected items from their batches",
  "Remove from batch {batchNumber}": "Remove from batch {batchNumber}",
  "Remove from batches {batchNumbers}": "Remove from batches {batchNumbers}",
  "No items without batch to create batch": "No items without batch to create batch",
  "No items without batch to add": "No items without batch to add",
  "No items with batch to remove": "No items with batch to remove",
  "Items added to batch successfully": "Items added to batch successfully",
  "Items removed from batch successfully": "Items removed from batch successfully",
  "Failed to manage batch": "Failed to manage batch",
  "No batch selected": "No batch selected",
  "Items from different batches": "Items from different batches",
  "Batches: {batchNumbers}": "Batches: {batchNumbers}",
  "Selected items belong to different batches. They will be removed from their current batches.": "Selected items belong to different batches. They will be removed from their current batches.",
  "the batch number": "the batch number",
  "Next batch number": "Next batch number",
  "Last batch created": "Last batch created",
  "Must be greater than": "Must be greater than",
  "status": "status",
  "edit-n-items": "Edit 1 item|Edit {n} items",
  "edit-n-jobs": "Edit 1 job|Edit {n} jobs",
  "none": "None",
  "width-units": "Width units",
  "Multiple": "Multiple",
  "MULTIPLE_VALUES_INDICATOR": "Multiple",
  "there-was-an-error-editing-the-order-items": "There was an error editing the order items",
  "order-items-updated-successfully": "Items updated successfully",
  "search-by-email": "Search by email",
  "search-by-phone": "Search by phone",
  "search-by-address": "Search by address",
  "search-by-city": "Search by city",
  "search-by-state": "Search by state",
  "search-by-zip": "Search by zip",
  "search-by-country": "Search by country",
  "select-date": "Select date",
  "View all": "View all",
  "by-material": "By material",
  "by-customer": "By customer",
  "by-batch": "By batch",
  "by-order-type": "By order type",
  "by-due-date": "By due date",
  "by-creation-date": "By creation date",
  "Buckets": "Buckets",
  "Batch": "Batch",
  "total-items": "Total items",
  "total-length": "Total length",
  "By": "By",
  "customer": "customer",
  "orderType": "order type",
  "date": "date",
  "creationDate": "creation date",
  "without-material": "Without material",
  "search-by-order-type": "Search by order type",
  "Without": "Without",
  "this-week": "This week",
  "old": "Expired",
  "rest": "Future",
  "batch": "batch",
  "no-due-date": "Without due date",
  "next-week": "Next week",
  "tomorrow": "Tomorrow",
  "Search by batch": "Search by batch",
  "selected-n-length": "{n} {units} selected",
  "Cards": "Cards",
  "List": "List",
  "quantity": "quantity",
  "the quantity": "the quantity",
  "the width": "the width",
  "the length": "the length",
  "the widthUnits": "the width units",
  "the lengthUnits": "the length units",
  "the material": "the material",
  "the workflowStage": "the workflow stage",
  "the printer": "the printer",
  "the scheme": "the scheme",
  "the layout": "the layout",
  "There are no schemes configured for this printer": "There are no schemes configured for this printer",
  "Uploads": "Uploads",
  "Clear all": "Clear all",
  "No uploads": "No uploads",
  "Some order items already have a batch": "Some bucket items already belong to a batch",
  "create-a-batch-with-n-elements-for-this-bucket": "Create a batch with {n} element for this bucket?|Create a batch with {n} elements for this bucket?",
  "Path": "Path",
  "Select layout": "Select layout",
  "Select customer": "Select customer",
  "select-a-user": "Select user",
  "Order ID": "Order ID",
  "Item ID": "Item Id",
  "Split PDF": "Split PDF",
  "pdf-has-n-pages-split-question": "The PDF \"{name}\" has {count} pages. Do you want to split each page into a separate item?",
  "Split into separate items": "Split into separate items",
  "Keep as single item": "Keep as single item",
  "Select pages to import": "Select pages to import",
  "Grid view": "Grid view",
  "List view": "List view",
  "n-pages-selected": "{count} of {total} pages selected|{count} of {total} pages selected",
  "Import": "Import",
  "Loading previews...": "Loading previews...",
  "Connected Devices": "Connected Devices",
  "connect-with-qr-reader": "Connect with QR Reader",
  "2-open-the-app-go-to-setting-click-on-add-button-and-scan-the-qr-code": "2. Open the app, go to Settings, click on '+' button and scan the QR code",
  "1-download-the-qr-reader-app": "1. Download the QR Reader app",
  "move-to-next-stage": "Move to next stage",
  "view-order": "View order",
  "view-batch": "View batch",
  "the currentFile": "the file",
  "destination": "Destination",
  "printer": "Printer",
  "Website": "Website",
  "Social Networks": "Social Networks",
  "Choose platform": "Choose platform",
  "Choose a platform": "Choose a platform",
  "URL completa": "Complete URL",
  "Network name": "Network name",
  "Link with user": "Link / {'@'}user",
  "View website": "View website",
  "Other social network": "Other social network",
  "No social networks added": "No social networks added",
  "Add social network": "Add social network",
  "yourusername": "yourusername",
  "edit-1-item": "Edit 1 item",
  "Export": "Export",
  "change-action": "Change action",
  "multiple-values": "Multiple values",
  "Printer-updated-successfully": "Printer updated successfully",
  "There-was-an-error-updating-the-layout": "There was an error updating the layout",
  "There-was-an-error-updating-the-printer": "There was an error updating the printer",
  "Are-you-sure-delete-printers": "Are you sure you want to delete the selected printers?",
  "Are-you-sure-delete-printer": "Are you sure you want to delete the selected printer?",
  "Printers deleted successfully": "Printers deleted succesfully",
  "There-was-an-error-deleting-the-printers": "There was an error deleting the printers",
  "There-was-an-error-deleting-the-materials": "There was an error deleting the materials",
  "Materials deleted successfully": "Materials deleted succesfully",
  "Are-you-sure-delete-material": "Are you sure you want to delete the selected material?",
  "Are-you-sure-delete-materials": "Are you sure you want to delete the selected materials?",
  "Loading layouts data": {
    " Please wait": "Loading layouts data. Please wait"
  },
  "Connect-your-device-to-scan-QR": "Connect your device to scan QR codes from PDFs and go straight to the item’s action page.",
  "Files": "Files",
  "Preprocess layout": "Preprocess layout",
  "Batches": "Batches",
  "unassigned-jobs": "Unassigned jobs",
  "printer-queue": "Printer queue",
  "Layout applied": "Layout applied",
  "end-date": "End date",
  "aborted-date": "Abort date",
  "Done Items": "Done Items",
  "jobs": "job|jobs",
  "send-to-printer": "Send to printer",
  "move-to-printer": "Move to printer",
  "Print Jobs": "Print Jobs",
  "Update Date": "Update Date",
  "select-order-type": "Select Order Type",
  "select-batch": "Select batch",
  "cannot-edit-layout-when-in-printers-or-done-stage": "Cannot edit layout when in 'Printers' type or 'Done' group stages",
  "cannot-edit-scheme-when-in-printers-or-done-stage": "Cannot edit scheme when in 'Printers' type or 'Done' group stages",
  "cannot-edit-printer-when-in-printers-or-done-stage": "Cannot edit the printer when in 'Printers' type or 'Done' group stages",
  "Cannot save with a hidden printer": "Cannot save when the stage is of type 'Printers' and the selected printer is not visible",
  "column-order-not-configured-yet": "The column order has not been configured in 'Configuration' yet",
  "Reset Order": "Reset Order",
  "Order Columns": "Order Columns",
  "Default column order and visibility": "Default column order and visibility",
  "Configure Columns": "Configure Columns",
  "Configure default column order": "Configure default column order",
  "Default Column Order": "Default Column Order",
  "Reorder Columns": "Reorder Columns",
  "at-least-one-of-the-selected-items-is-currently-in-the-printers-stage-the-attached-print-job-will-be-cancelled-are-you-sure-you-want-to-move-it-out-of-that-stage": "The selected item is currently in the Printers stage. The attached print job will be cancelled if it has not started yet. Are you sure you want to move it out of the stage?|At least one of the selected items is currently in the Printers stage. The attached print jobs will be cancelled if they have not started yet. Are you sure you want to move them out of the stage?",
  "confirm-removing-from-printers-stage": "Confirm removing from Printers stage",
  "yes-move-it": "Yes, move it",
  "no-keep-it": "No, keep it",
  "the-selected-item-is-currently-in-the-printers-stage": "The selected item is currently in the Printers stage.|At least one of the selected items is currently in the Printers stage.",
  "Default printer": "Default printer",
  "Default scheme": "Default scheme",
  "API Tokens & Devices": "API Tokens & Devices",
  "Starting batch number": "Starting batch number (next batch will be this number)",
  "Configure which columns are visible and their default order": "Configure which columns are visible and their default order. These settings will be used as the reset values for all users.",
  "No tokens yet": "No tokens yet",
  "A token with this name already exists": "A token with this name already exists, please choose a different name",
  "Error generating token": "Error generating token",
  "Enter your token name": "Enter your token name",
  "Generate a new token": "Generate a new token",
  "archive": "Archive",
  "cancel-jobs": "Cancel jobs",
  "cancel-print-jobs": "Cancel print job|Cancel print jobs",
  "cancel-print-job-disabled": "It is only possible to cancel jobs with the status 'Pending' or 'Assigned'",
  "reason-for-cancelling": "Reason for cancelling",
  "enter-reason-for-cancelling": "Enter a reason for cancelling the print job|Enter a reason for cancelling the print jobs",
  "do-you-want-to-cancel-these-print-jobs": "Do you want to cancel this print job?|Do you want to cancel these print jobs?",
  "cancel-print-job-printer-queue-warning": "Cancelling a print job in this status will only change its status to CANCELLED in Inèdit Connect. It will not cancel it in the printer queue. If the job is still in the printer, you must remove it manually from the printer.",
  "i-understand-cancel-print-job-printer-queue-warning": "I understand that I may need to remove this job manually from the printer queue.",
  "print-jobs-cancelled-successfully": "Print job cancelled successfully|Print jobs cancelled successfully",
  "failed-to-cancel-print-jobs": "Failed to cancel print jobs",
  "unable-to-confirm-cancellation": "Unable to confirm cancellation",
  "cancel-print-job-timeout-warning": "The cancellation could not be confirmed within the expected time. The job status may not have been updated in the printer queue.",
  "confirm-cancellation-anyway": "Confirm cancellation anyway",
  "print-job-in-printer-queue": "Print jobs in printer queue",
  "print-job-in-printer-queue-message": "At least one of the selected print jobs is currently in the printer queue. The cancellation will be sent to the Control Center for processing.",
  "jobs-archived-successfully": "Jobs archived successfully",
  "error-while-archiving-jobs": "Error while archiving jobs",
  "Drag to reorder and toggle visibility as your default": "Drag to reorder and toggle visibility. This order will be used as your default column order.",
  "Drag to reorder and toggle visibility as your company": "Drag to reorder and toggle visibility. This will become the default for all users when they reset their columns.",
  "customers": "customers",
  "save-and-create-job": "Save and create job with layout",
  "Order Layout": "Layout",
  "printJobStatus": {
    "PENDING": "Pending",
    "ASSIGNED": "Assigned",
    "PROCESSING": "Processing",
    "QUEUED": "Queued",
    "PRINTING": "Printing",
    "COMPLETED": "Completed",
    "ABORTED": "Aborted",
    "CANCELLED": "Cancelled"
  },
  "printJobType": {
    "PRINT": "Print",
    "REPRINT": "Reprint",
    "blankSpace": "Gap"
  },
  "Select Control Center": "Select Control Center",
  "are-you-sure-you-want-to-delete-this-comment": "Are you sure you want to delete this comment?",
  "Choose a printer": "Choose a printer",
  "Choose a scheme": "Choose a scheme",
  "Download PDF": "Download PDF",
  "Error generating the job of the order": "Error generating the job of the order",
  "Error generating the job of the order in the partner": "Error generating the job of the order in the partner",
  "Failed to load items for PDF": "Failed to load items for PDF",
  "Go Back": "Go Back",
  "Loading ink types data. Please wait": "Loading ink types data. Please wait",
  "Mail sent": "Mail sent!",
  "Optimize outgoing jobs before sending them to your partner": "Optimize outgoing jobs before sending them to your partner",
  "Order Items": "Order Items",
  "PDF Preview": "PDF Preview",
  "reply-with-elipsis": "Reply...",
  "Version": "Version",
  "Wrong URL": "Wrong URL, please try again or contact with the the administrator",
  "download-pdf": "Download PDF",
  "Exported": "Exported",
  "item-moved-to-next-stage": "Item moved to next stage",
  "failed-to-move-item-to-next-stage": "Failed to move item to next stage",
  "unassigned": "Unassigned",
  "Select type": "Select type",
  "export-csv": "Export CSV",
  "export-excel": "Export Excel",
  "group-by": "Group by",
  "export-excel-selection-hint": "Exporting {n} selected item(s).",
  "export-excel-filters-hint": "No selection — exporting items matching the current filters.",
  "export-excel-bucket-hint": "Exporting items in this bucket.",
  "Excel exported successfully": "Excel exported successfully",
  "There was an error exporting the Excel": "There was an error exporting the Excel",
  "Print job created successfully": "Print job created successfully",
  "Failed to create print job": "Failed to create Print Job",
  "Remove selected printer from jobs": "Remove selected printer from jobs",
  "No printer": "No printer",
  "Ink consumption": "Ink consumption",
  "Percentage": "Percentage",
  "Printed length": "Printed length",
  "Print job updated successfully": "Print Job updated successfully",
  "Failed to update print job": "Failed to update Print Job",
  "Edit print job": "Edit Print Job",
  "Action": "Action",
  "action": {
    "Nothing": "None",
    "Queue": "Queue",
    "Print": "Queue and Print"
  },
  "no-print-jobs": "No Print Jobs",
  "width-is-required-and-must-be-greater-than-0": "Width is required and must be greater than 0",
  "length-is-required-and-must-be-greater-than-0": "Length is required and must be greater than 0",
  "quantity-is-required-and-must-be-greater-than-0": "Quantity is required and must be greather than 0",
  "cannot-edit-print-job-in-status-status": "Cannot edit print job in status {status}",
  "no-orders": "No orders",
  "action-is-required": "Select an action",
  "cant-print-automatically-without-a-printer-and-scheme": "Can't print automatically without a printer and scheme",
  "cant-print-automatically-with-a-printer-type-destination": "Can't print automatically with a printer type 'Destination'",
  "confirm-remove-from-queue": "Remove from queue",
  "confirm-remove-from-queue-message": "This print job will be removed from the queue. Do you want to continue?",
  "Print": "Print...",
  "Print Jobs History": "Print Jobs History",
  "New": "New",
  "no-users-found": "No users found",
  "this-stage-cannot-be-deleted-because-it-is-set-as-the-default-stage-of-the-workflow": "This stage cannot be deleted because it is set as the default stage of the workflow",
  "this-stage-cannot-be-deleted-because-there-are-order-types-using-it": "This stage cannot be deleted because there are order types using it",
  "this-stage-cannot-be-deleted-because-it-is-set-as-the-default-stage-in-some-of-your-partners-preferences": "This stage cannot be deleted because it is set as the default stage in some of your partners' preferences",
  "this-stage-cannot-be-deleted-because-it-has-order-items": "This stage cannot be deleted because it has order items",
  "move-or-cancel-disabled": "It is only possible to move or cancel jobs with the status 'Pending' or 'Assigned'",
  "the-item-does-not-exist-or-its-an-item-from-another-company": "The item does not exist or it's from another company",
  "abort": "Abort",
  "reason-for-aborting": "Reason for aborting",
  "enter-reason-for-aborting": "Enter a reason for aborting the print job",
  "field-is-required": "This field is required",
  "field-must-have-at-least-n-characters": "This field must have at least {n} characters",
  "print-job-aborted-successfully": "Print job aborted successfully",
  "Custom field has values and cannot be deleted": "Custom field has values and cannot be deleted",
  "Go back": "Go back",
  "Download Log": "Download Job Details",
  "meters-selected": "meters selected",
  "total-meters": "total meters",
  "New print job": "New print job",
  "Order Comments": "Order Comments",
  "Item Comments": "Item Comments",
  "layout-is-not-compatible-with-this-file-extension": "Layout is not compatible with this file extension",
  "Printers with print jobs cannot be deleted": "Printers with pending print jobs cannot be deleted",
  "you-dont-have-permission-to-edit-print-jobs": "You don't have permission to edit print jobs",
  "move-to-stage": "Move to stage {stage}",
  "item-moved-to-stage": "Item moved to stage {stage}",
  "you-dont-have-permission-to-create-print-jobs": "You don't have permission to create print jobs",
  "the-order-item-is-in-error-status": "The order item is in error status",
  "no-printers-stage-configured": "You need to have a stage with Type \"Printers\" to create print jobs",
  "Order comments": "Order comments",
  "Item comments": "Item comments",
  "Delivery date": "Delivery date",
  "Creator": "Creator",
  "deselect-all": "Deselect all",
  "ASSIGNED": "ASSIGNED",
  "CANCELLED": "CANCELLED",
  "QUEUED": "QUEUED",
  "ABORTED": "ABORTED",
  "PENDING": "PENDING",
  "PRINTING": "PRINTING",
  "Abort date": "Abort date",
  "Abort Date": "Abort Date",
  "COMPLETED": "COMPLETED",
  "completed": "Completed",
  "pending": "Pending",
  "assigned": "Assigned",
  "processing": "Processing",
  "queued": "Queued",
  "printing": "Printing",
  "aborted": "Aborted",
  "cancelled": "Cancelled",
  "Printed Length": "Printed Length",
  "Ink Consumption": "Ink Consumption",
  "End Date": "End Date",
  "Archive Date": "Archive Date",
  "there-was-an-error-with-the-item-size-or-position-please-adjust-the-variables-and-try-again": "There was an error with the item size or position. Please adjust the variables and try again.",
  "some-image-files-formats-are-not-supported-in-layouts": "Some image files formats are not supported in layouts",
  "and-move-to": "and move to",
  "PROCESSING": "PROCESSING",
  "Pause": "Pause",
  "Resume": "Resume",
  "Unknown": "Unknown",
  "Offline": "Offline",
  "Online": "Online",
  "Default measurement unit": "Default measurement unit",
  "devices-and-apps": "Devices and Apps",
  "qr-reader": "QR Reader",
  "API Tokens": "API Tokens",
  "connect-with-neocatalog-to-acces-to-all-your-designs-you-will-be-able-to-create-new-orders-using-any-of-your-neocatalog-designs-and-colorways-with-just-a-click": "Connect with neoCatalog to acces to all your designs. You will be able to create new orders using any of your neoCatalog designs and colorways with just a click.",
  "connect-with-neocatalog": "Connect with neoCatalog",
  "neoCatalog": "neoCatalog",
  "edit-neocatalog-connection": "Edit neoCatalog connection",
  "neocatalog-connection-name": "Connection name",
  "neocatalog-api-token": "neoCatalog API token",
  "neocatalog-api-token-help": "Create a permanent API key in neoCatalog (Administration → Management → Users → Choose user → API Key) and paste it here. ",
  "leave-blank-to-keep-current-token": "Leave blank to keep the current token",
  "neocatalog-connection-created": "neoCatalog connected successfully",
  "neocatalog-connection-updated": "neoCatalog connection updated",
  "neocatalog-disconnected": "neoCatalog disconnected",
  "do-you-want-to-disconnect-neocatalog": "Do you want to disconnect neoCatalog?",
  "Error connecting to neoCatalog": "Error connecting to neoCatalog",
  "Error disconnecting neoCatalog": "Error disconnecting neoCatalog",
  "Connect": "Connect",
  "Disconnect": "Disconnect",
  "Token": "Token",
  "API Token": "API Token",
  "add-from-neocatalog": "Add from neoCatalog",
  "replace-from-neocatalog": "Replace from neoCatalog",
  "search-designs-by-name-or-code": "Search designs by name or code",
  "search-colorways-by-name-or-code": "Search colorways by name or code",
  "no-designs-found": "No designs found",
  "no-colorways-found": "No colorways found",
  "Error loading neoCatalog designs": "Error loading neoCatalog designs",
  "Error loading neoCatalog colorways": "Error loading neoCatalog colorways",
  "Error downloading neoCatalog file": "Error downloading neoCatalog file",
  "Next": "Next",
  "Test": "Test",
  "neocatalog-connection-test-ok": "neoCatalog connection is valid",
  "neocatalog-connection-test-failed": "neoCatalog connection test failed",
  "enter-a-valid-url": "Enter a valid URL, including http:// or https://. Local addresses such as https://hostname.local:2001 are allowed.",
  "neocatalog-could-not-reach-server": "Could not reach neoCatalog at this URL. Check that the address is correct and that the server is reachable.",
  "error-replacing-order-item-file-with-neocatalog-file": "Error replacing order item file with neoCatalog file",
  "error-adding-order-item-file-with-neocatalog-file": "Error adding order item file with neoCatalog file",
  "Hide Archived": "Hide Archived",
  "reset-sort": "Reset sort",
  "Move to top": "Move to top",
  "Move up": "Move up",
  "Move down": "Move down",
  "Move to bottom": "Move to bottom",
  "reset-sort-to-reorder-manually": "Reset sort to reorder manually",
  "only-possible-to-move-jobs-with-status": "It is only possible to move jobs with the status 'Pending' or 'Assigned'",
  "OrderItem": "Order item",
  "PrintJob": "Print Job",
  "Configure Order Items Columns": "Configure Order Items Columns",
  "Drag to reorder and toggle visibility for order item columns": "Drag to reorder and toggle which columns are visible in order items.",
  "order-items-dialog-created": "Order items dialog created",
  "custom-field": "Custom",
  "select-partner-stage-tooltip": "Select a workflow stage of type Partners to enable this option",
  "no-partners-available": "No partners available",
  "no-partners-available-tooltip": "No partners available for your company. Add partners first to use this feature.",
  "no-accepted-partners": "No accepted partners",
  "no-pending-invitations": "No pending invitations",
  "no-blocked-partners": "No blocked partners",
  "this-field-is-used-in-a-dialog-and-cannot-be-changed": "This field is used in a dialog and cannot be changed",
  "total": "total",
  "selected": "selected",
  "History": "History",
  "material": "Material",
  "no-maximum": "No maximum",
  "choose-the-gap-size": "Choose the gap size",
  "print-blank-space-between-materials-in-batch": "Print gap between materials in a batch",
  "print-blank-space-between-batches": "Print gap between batches",
  "force-sequential-jobs-description": "Send jobs in queue order. The next job waits until the previous job on the same printer has finished processing.",
  "Information": "Information",
  "controlCenterErrors": {
    "printJobStuck": "Error: Print job stuck in processing status for a long time",
    "fileUrlMissing": "Error: File URL missing.",
    "errorDownloadingFile": "Error downloading file:",
    "errorSendingOrder": "Error: Error sending order to print server",
    "jobRemovedFromQueue": "Error: Job has been removed from queue."
  },
  "Add description": {
    "": {
      "": "Add description..."
    }
  },
  "add-description": "Add description...",
  "No preview available": "No preview available",
  "Editing is disabled because item is accepted": "Editing is disabled because item is accepted",
  "Editing is disabled because item is already accepted": "Editing is disabled because item is already accepted"
}
